import type { FaireProductEntity } from "../../entity_types/product";

export const p_x39jatgc4s: FaireProductEntity = {
  token: "p_x39jatgc4s",
  type: "product",
  name: "Gold HandCuff Connector Charm for Jewelry Making CNG002",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/ae4e27d889af6fca9d05dcff13bfea70d343931ef4ba5df35809ebdb1ce9215d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0f3d9724694af0c5429b3382b7277c976d8e1631f22ce5fa3cdc3ff58c81dfdb.jpeg",
    "https://cdn.faire.com/fastly/243dee6326524fa41beabc3ff639a6aec2d4b1a71e76dcc3ae56128a8b03b9ea.jpeg",
    "https://cdn.faire.com/fastly/61906bfc3fbd0f7fe0a63b5b96e66db69d418896f8c10d26628bb557c023d25a.jpeg",
    "https://cdn.faire.com/fastly/bff24fef657f0e2992ab60e7ed57fdc03f37e86048c8145f33aa3dfce731c677.jpeg",
    "https://cdn.faire.com/fastly/ee0ee75ce2a483dd36a37eec03ca767003e2a48dbc278c6d09d6a32adf6f1d8d.jpeg",
    "https://cdn.faire.com/fastly/abf991b2d669e087529580d45cc889e30f5bdb9b49ab1912f9174752890e6ba6.jpeg",
  ],
  priceDollars: 24.8,
  description:
    "14K Gold Plated Handcuff Connector That Can Be Used To Design Necklace Or Bracelet CNG002\n*CHAIN IS NOT INCLUDED\n14K Gold plating Over Brass, coated with non tarnishing coat\nCharm Measurements:22.5mm x 8.5mm\nCharm Thickness:2mm\nSizes Are Approximate\nMetal Color: Gold\ncadmium and nickel free\nBulk discount is available at drop down menu\nShip from Los Angeles",
  tags: [],
  msrpDollars: 49.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:59.840Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
